import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { TableSortOption } from '@evinced-private/ui-common';

import { IUniqueIssuesResult } from 'src/apps/dashboard/services/queries/unique-issues/helpers/transformResults';
import { getUniqueIssues } from 'src/apps/dashboard/services/unique-issues/UniqueIssuesService';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { DASHBOARD_UNIQUE_ISSUES } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useUniqueIssuesData = (
	filters: IFilterOptions,
	page: number,
	sizePerPage: number,
	sort?: TableSortOption,
	enabled = true
): UseQueryResult<IUniqueIssuesResult> => {
	return useQuery(
		[DASHBOARD_UNIQUE_ISSUES, filters, page, sizePerPage, sort],
		async (): Promise<IUniqueIssuesResult> =>
			getUniqueIssues({
				filters,
				page,
				sizePerPage,
				sort
			}),
		{
			enabled,
			keepPreviousData: true,
			staleTime: 5 * 60 * 1000,
			cacheTime: 10 * 60 * 1000,
			refetchOnWindowFocus: false
		}
	);
};
